import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import LeadModal from "@/components/LeadModal";

const REVEAL_SELECTORS = [
  ".sec-head", ".why__item", ".eco__card", ".sol__card",
  ".communities__copy", ".communities__map", ".communities__child",
  ".cta__inner", ".ip-mv__card", ".ip-story__body", ".founders-box",
  ".founders-note", ".ip-value", ".dp-overview__copy", ".dp-capabilities",
  ".dp-service", ".dp-stat", ".dp-cta__inner", ".dp-siblings__row",
  ".contact-form-wrap", ".contact-info", ".founder",
].join(",");

export default function Layout() {
  const { pathname, state } = useLocation();

  useEffect(() => {
    if (!state?.scrollTo) window.scrollTo(0, 0);
  }, [pathname, state]);

  // Scroll-reveal: fade + rise as elements enter the viewport
  useEffect(() => {
    const prefersReduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    const t = setTimeout(() => {
      const els = Array.from(document.querySelectorAll(REVEAL_SELECTORS));
      if (prefersReduced) {
        els.forEach((el) => el.classList.add("reveal", "is-visible"));
        return;
      }
      els.forEach((el) => {
        if (!el.classList.contains("reveal")) el.classList.add("reveal");
        const parent = el.parentElement;
        if (parent) {
          const sibs = Array.from(parent.children).filter((c) => c.classList.contains("reveal"));
          const i = sibs.indexOf(el);
          if (i > 0) el.style.transitionDelay = Math.min(i * 70, 350) + "ms";
        }
      });
      const io = new IntersectionObserver(
        (entries) => {
          entries.forEach((e) => {
            if (e.isIntersecting) {
              e.target.classList.add("is-visible");
              io.unobserve(e.target);
            }
          });
        },
        { threshold: 0.12, rootMargin: "0px 0px -8% 0px" }
      );
      els.forEach((el) => io.observe(el));
      Layout._io = io;
    }, 60);
    return () => {
      clearTimeout(t);
      if (Layout._io) { Layout._io.disconnect(); Layout._io = null; }
    };
  }, [pathname]);

  return (
    <div className="site">
      <Navbar />
      <main>
        <Outlet />
      </main>
      <Footer />
      <LeadModal />
    </div>
  );
}
